module.exports = __webpack_public_path__ + "static/img/news-image.9446647.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/news/news-image.png
// module id = h2sG
// module chunks = 1